import {
  Container,
  Button,
  Stack,
  VStack,
  Flex,
  Text,
  Box,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  RadioGroup,
  Radio,
} from "@chakra-ui/react";
import React, { useState } from "react";
import DrawMapView from "../pages/DrawMapView";

import { pointsLocator } from "../data/Locator";

const [ features, foodSet, womenSet, menSet, kidsSet, toysSet, saniSet ] = pointsLocator();

const MapGrid = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const [finalPoints, setFinalPoints] = useState(features);

  const [pointValue, setPointValue] = React.useState('1');

  function onTagSelect(e) {
    setPointValue(e);

    if (e === '1') setFinalPoints(features);
    if (e === '2') setFinalPoints(foodSet);
    if (e === '3') setFinalPoints(womenSet);
    if (e === '4') setFinalPoints(menSet);
    if (e === '5') setFinalPoints(kidsSet);
    if (e === '6') setFinalPoints(toysSet);
    if (e === '7') setFinalPoints(saniSet);

    onClose();
  }

  return (
    <Box backgroundColor={"#EFE1CC80"}>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Filter Centres</DrawerHeader>

          <DrawerBody>
            <Stack spacing='24px'>
                <Flex>
                <RadioGroup onChange={onTagSelect} value={pointValue}>
                  <VStack alignItems='flex-start'>
                  {['All', 'Food', 'Women Clothing', "Men Clothing", "Kids Clothing", "Toys", "Sanitory"].map((tag, index) => (
                    <Radio
                      value={index + 1 + ""}
                      key={tag}
                      colorScheme={"gray"}
                    >
                      {tag}
                    </Radio>
                  ))}
                  </VStack>
                </RadioGroup>
                </Flex>
            </Stack>
          </DrawerBody>

          <DrawerFooter></DrawerFooter>
        </DrawerContent>
      </Drawer>
      <Container
        maxW={{ base: "auto", md: "7xl", lg: "7xl" }}
        py={4}
        height="min-content"
      >
        <Text color={"black"} py={6}>
            Below is a map displaying the donation centers near you that could
            use your help:
          </Text>
        <VStack spacing={5} alignContent="left">
          <Button ref={btnRef} colorScheme={"#5E856D"}
                bg={"#5E856D"} onClick={onOpen}>
            Filter Points
          </Button>
          <Box width={"auto"}>
            <DrawMapView points={finalPoints}/>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default MapGrid;
